export function lastInterestClick(local: string) {
  const nome = local.toLowerCase().replace(/ /g, '_');
  const value = `click_${nome}`;
  const key = 'lastClicked_adc';
  const getStorage = sessionStorage.getItem(key);

  if (!getStorage || !value.includes('product_card')) {
    sessionStorage.setItem(key, value);
  }
}

export function lastInterestClickBanner(local: string) {
  const key = 'lastClicked_adc';
  const indexStart = local.indexOf('=') + 1;
  const indexEnd = local.indexOf('=') + 3;
  const result = local.substring(indexStart, indexEnd);
  const value = `click_banner_${result}`;

  sessionStorage.setItem(key, value);
}
